import $ from 'jquery';
import 'jquery-validation';
import { alert, defaultModules } from '@pnotify/core';
import * as PNotifyMobile from '@pnotify/mobile';

defaultModules.set(PNotifyMobile, {});

const validateMessage = {
  KHONG_DUNG_DINH_DANG: 'Không đúng định dạng',
  NHAP_SO: 'Vui lòng nhập số',
  CHON_DU_LIEU: 'Vui lòng chọn dữ liệu',
  KHONG_DE_TRONG: (field) => `${field} không được để trống`,
  LON_HON: (size) => `Không được nhỏ hơn ${size} ký tự`,
  NHO_HON: (size) => `Không được lớn hơn ${size} ký tự`,
  GIONG_NHAU: (field) => `Vui lòng nhập cùng một giá trị với ${field}`,
};

const dataValidate = {
  name: {
    rule: {
      required: true,
      minlength: 2,
    },
    message: {
      required: validateMessage.KHONG_DE_TRONG('Tên tài khoản'),
      minlength: validateMessage.LON_HON('2'),
    },
  },
  phone: {
    rule: {
      number: true,
      minlength: 10,
      maxlength: 11,
    },
    message: {
      required: validateMessage.KHONG_DE_TRONG('Số điện thoại'),
      number: validateMessage.NHAP_SO,
      minlength: validateMessage.LON_HON('10'),
      maxlength: validateMessage.NHO_HON('11'),
    },
  },
  email: {
    rule: {
      email: true,
    },
    message: {
      required: validateMessage.KHONG_DE_TRONG('Email'),
      email: validateMessage.KHONG_DUNG_DINH_DANG,
    },
  },
  name: {
    rule: {
      required: true,
      minlength: 2,
    },
    message: {
      required: validateMessage.KHONG_DE_TRONG('Họ và tên'),
      minlength: validateMessage.LON_HON('2'),
    },
  },
  address: {
    rule: {
      required: true,
      minlength: 2,
    },
    message: {
      required: validateMessage.KHONG_DE_TRONG('Địa chỉ'),
      minlength: validateMessage.LON_HON('2'),
    },
  },
  select: {
    rule: {
      required: true,
    },
    message: {
      required: validateMessage.CHON_DU_LIEU,
    },
  },
};

const form = $('#registerform');
form.validate({
  errorElement: 'span',
  rules: {
    name: dataValidate.name.rule,
    phone: {
      required: true,
      ...dataValidate.phone.rule,
    },
    email: {
      required: true,
      ...dataValidate.email.rule,
    },
    i_agree: {
      required: true,
    },
    password: {
      required: true,
      minlength: 2,
    },
    passwordagain: {
      required: true,
      minlength: 2,
      equalTo: '#password',
    },
  },
  messages: {
    name: dataValidate.name.message,
    phone: dataValidate.phone.message,
    email: dataValidate.email.message,
    i_agree: {
      required: 'Bạn chưa đồng ý các điều khoản sử dụng',
    },
    password: {
      required: validateMessage.KHONG_DE_TRONG('Mật khẩu'),
      minlength: validateMessage.LON_HON('2'),
    },
    passwordagain: {
      required: validateMessage.KHONG_DE_TRONG('Mật khẩu'),
      minlength: validateMessage.LON_HON('2'),
      equalTo: validateMessage.GIONG_NHAU('Mật khẩu'),
    },
  },
});

$('#createaccount').on('click', () => {
  const isValid = form.valid();
  if (isValid) {
    form.submit();
  }
});

const form2 = $('#sign-up-to-receive');
form2.validate({
  errorElement: 'span',
  rules: {
    email: dataValidate.email.rule,
  },
  messages: {
    email: dataValidate.email.message,
  },
});

$('#js-sign-up-to-receive').on('click', () => {
  const isValid = form2.valid();
  if (isValid) {
    const form = form2.serializeArray();
    $('#js-sign-up-to-receive').prop('disabled', true);
    fetch(
      'POST',
      '/api/contact',
      {
        email: form?.find((e) => e.name === 'email')?.value,
        from: form?.find((e) => e.name === 'from')?.value,
      },
      (res) => {
        if (res?.status) {
          notification('success', 'Đăng ký thành công!');
        }
      },
      () => {
        notification('notice', 'Đăng ký không thành công!');
      },
      () => {
        $('#sign-up-to-receive input[name="email"]').val('');
        $('#js-sign-up-to-receive').prop('disabled', false);
      },
    );
  }
});

const form3 = $('#js-form-warranty-check');
form3.validate({
  errorElement: 'span',
  rules: {
    phone: {
      required: true,
      ...dataValidate.phone.rule,
    },
  },
  messages: {
    phone: dataValidate.phone.message,
  },
});
$('#js-form-warranty-check-button').on('click', () => {
  const isValid = form3.valid();
  if (isValid) {
    form3.submit();
  }
});

function validateSelect(form) {
  const formData = form.serializeArray();
  const province = formData?.find((e) => e.name === 'province')?.value;
  const district = formData?.find((e) => e.name === 'district')?.value;
  const wards = formData?.find((e) => e.name === 'wards')?.value;
  let countValidate = 0;
  if (!province || (province && province === 'ALL')) {
    countValidate += 1;
    $('#js-error-province').html('Vui lòng chọn Tỉnh/Thành');
  }

  if (!district || (district && district === 'ALL')) {
    countValidate += 1;
    $('#js-error-district').html('Vui lòng chọn Quận/Huyện');
  }

  if (!wards || (wards && wards === 'ALL')) {
    countValidate += 1;
    $('#js-error-wards').html('Vui lòng chọn Phường/Xã');
  }

  if (countValidate !== 0) {
    return false;
  }

  return true;
}

$('#js-order-save').on('click', (e) => {
  e.preventDefault();
  const form = $('#js-order-form');
  form.validate({
    errorElement: 'span',
    rules: {
      consignee_name: dataValidate.name.rule,
      consignee_phone: dataValidate.phone.rule,
      consignee_address: dataValidate.address.rule,
    },
    messages: {
      consignee_name: dataValidate.name.message,
      consignee_phone: dataValidate.phone.message,
      consignee_address: dataValidate.address.message,
    },
  });

  const isValid = form.valid();
  const isValidSelect = validateSelect(form);
  if (isValid && isValidSelect) {
    const formData = form.serializeArray();
    $('#js-order-save').prop('disabled', true);
    fetch(
      'POST',
      '/api/order',
      {
        consignee_name: formData?.find((e) => e.name === 'consignee_name')
          ?.value,
        consignee_email: formData?.find((e) => e.name === 'consignee_email')
          ?.value,
        consignee_phone: formData?.find((e) => e.name === 'consignee_phone')
          ?.value,
        consignee_address: formData?.find((e) => e.name === 'consignee_address')
          ?.value,
        province_id: formData?.find((e) => e.name === 'province')?.value,
        province_name: formData?.find((e) => e.name === 'province_name')?.value,
        district_id: formData?.find((e) => e.name === 'district')?.value,
        district_name: formData?.find((e) => e.name === 'district_name')?.value,
        wards_id: formData?.find((e) => e.name === 'wards')?.value,
        wards_name: formData?.find((e) => e.name === 'wards_name')?.value,
        payment_status: formData?.find((e) => e.name === 'payment_status')
          ?.value,
        payment_note: formData?.find((e) => e.name === 'payment_note')?.value,
      },
      (res) => {
        if (res?.status) {
          // notification('success', 'Đặt hàng thành công!');
          window.location.pathname = '/thanh-toan-hoan-thanh.html';
        }
      },
      () => {
        notification('error', 'Đặt hàng không thành công!', false, 5000);
      },
      () => {
        $('#js-order-save').prop('disabled', false);
        setTimeout(() => {
          window.location.reload();
          // window.location.pathname = '/thanh-toan-hoan-thanh.html'
        }, 1000);
      },
    );
  }
});

let timeout = null;
$('#js-header-search').on('keyup', (e) => {
  $('#js-header-search-show').removeClass('display');
  $('#js-header-search-show').empty();
  const value = e?.target?.value;
  if (!value) {
    clearTimeout(timeout);
    return;
  }

  const divLoad = document.createElement('div');
  divLoad.setAttribute(
    'style',
    'padding: 10px;background-color:#fff;position: absolute;z-index:2;width:100%;min-height:30px;border-bottom-left-radius:4px;border-bottom-right-radius:4px',
  );
  divLoad.innerHTML = `<span style="position: absolute" class="iconfont-spinner loading-spin"></span>`;
  $('#js-header-search-show').append(divLoad);
  clearTimeout(timeout);
  timeout = setTimeout(function () {
    fetch(
      'GET',
      '/api/post/search',
      {
        q: value,
      },
      (res) => {
        $('#js-header-search-show').empty();
        if (res && res?.data?.length !== 0) {
          const div = document.createElement('div');
          div.setAttribute('class', 'block');
          res?.data.forEach((element) => {
            const path = '/' + element?.path + '.html';
            const div2 = document.createElement('div');
            const div3 = document.createElement('div');
            const div4 = document.createElement('a');
            const div5 = document.createElement('div');
            const dName = document.createElement('a');
            const dPrice = document.createElement('span');
            div3.setAttribute('class', 'image');
            div4.style.backgroundImage = `url(${
              element?.image ? element?.image : '/images/no-image.png'
            })`;
            div4.setAttribute('href', path);
            div3.append(div4);
            dName.setAttribute('href', path);
            dName.textContent = element?.title;
            dPrice.textContent = 'SKU: ' + element?.product_code || '';
            div5.setAttribute('class', 'infos');
            div5.append(dName, dPrice);
            div2.setAttribute('class', 'item');
            div2.append(div3, div5);
            div.append(div2);
          });
          const divTong = document.createElement('a');
          divTong.setAttribute('class', 'mess-total');
          divTong.setAttribute('id', 'js-search-total');
          divTong.innerHTML = `Xem thêm <strong>${res?.count}</strong> với từ khóa "<strong>${value}</strong>"`;
          divTong.onclick = function () {
            $('#js-header-form-search').submit();
          };
          $('#js-header-search-show').addClass('display');
          $('#js-header-search-show').append(div, divTong);
        }
      },
      () => {},
      () => {},
    );
  }, 1500);
});

function fetch(
  method = 'GET',
  endpoint = '',
  data,
  onDone = () => {},
  onFail = () => {},
  always = () => {},
) {
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
  });
  $.ajax({
    method: method,
    url: endpoint,
    data: data,
    cache: false,
  })
    .done(function (res) {
      onDone(res);
    })
    .fail(function (res) {
      onFail(res);
    })
    .always(function (res) {
      always(res);
    });
}

function notification(type = 'success', text = false, title = false, delay = 2000) {
  // https://github.com/sciactive/pnotify#getting-started
  // type: 'notice', 'info', 'success', or 'error'
  // title: string, an element, or false for no title
  // text: string, an element, or false for no text
  // animateSpeed: 'slow', 'normal', or 'fast'. Respectively, 400ms, 250ms, 100ms
  return alert({
    title: title,
    text: text,
    type: type,
    animateSpeed: 'normal',
    delay: delay,
    hide: true,
    mouseReset: true,
    closerHover: true,
    sticker: false,
  });
}
